// 支援的區塊鏈配置
export const SUPPORTED_CHAINS = {
  ethereum: {
    id: 1,
    name: 'Ethereum',
    symbol: 'ETH',
    blockTime: 12000, // 12 秒
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: true,
      mevBlocker: true,
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      flashbots: 'https://rpc.flashbots.net',
      mevBlocker: 'https://rpc.mevblocker.io',
      blocksec: 'https://eth.rpc.blocksec.com'
    },
    rpcs: [
      { name: 'Infura HTTP', url: 'https://mainnet.infura.io/v3/YOUR_API_KEY', type: 'http' },
      { name: 'Infura WebSocket', url: 'wss://mainnet.infura.io/ws/v3/YOUR_API_KEY', type: 'ws' },
      { name: 'Alchemy HTTP', url: 'https://eth-mainnet.alchemyapi.io/v2/YOUR_API_KEY', type: 'http' },
      { name: 'Alchemy WebSocket', url: 'wss://eth-mainnet.alchemyapi.io/v2/YOUR_API_KEY', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/eth', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/eth/ws', type: 'ws' },
      { name: 'Public HTTP', url: 'https://ethereum.publicnode.com', type: 'http' },
      { name: 'Public WebSocket', url: 'wss://ethereum.publicnode.com', type: 'ws' },
      { name: 'CloudFlare HTTP', url: 'https://cloudflare-eth.com', type: 'http' }
    ],
    explorer: 'https://etherscan.io'
  },
  bsc: {
    id: 56,
    name: 'BNB Smart Chain',
    symbol: 'BNB',
    blockTime: 450, // 0.45s after BSC Fermi hard fork
    // 交易類型支援
    supportsEIP1559: false, // BSC 不支援 EIP-1559
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: false,
      blocksec: true, // BlockSec Anti-MEV RPC (免費)
      blockrazor: true, // BlockRazor private mempool and ordered bundles
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      blocksec: 'https://bsc.rpc.blocksec.com'
    },
    rpcs: [
      { name: 'BSC Official HTTP', url: 'https://bsc-dataseed.binance.org', type: 'http' },
      { name: 'BSC Official WebSocket', url: 'wss://bsc-ws-node.nariox.org:443', type: 'ws' },
      { name: 'BSC 1 HTTP', url: 'https://bsc-dataseed1.defibit.io', type: 'http' },
      { name: 'BSC 2 HTTP', url: 'https://bsc-dataseed1.ninicoin.io', type: 'http' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/bsc', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/bsc/ws', type: 'ws' },
      { name: 'Public HTTP', url: 'https://bsc.publicnode.com', type: 'http' }
    ],
    explorer: 'https://bscscan.com'
  },
  polygon: {
    id: 137,
    name: 'Polygon',
    symbol: 'POL',
    blockTime: 1500, // 1.5s after 2026 Polygon throughput upgrade
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: true
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      mevBlocker: 'https://rpc.mevblocker.io/polygon'
    },
    rpcs: [
      { name: 'Public HTTP', url: 'https://polygon.publicnode.com', type: 'http' },
      { name: 'Polygon Official HTTP', url: 'https://polygon-rpc.com', type: 'http' },
      { name: 'Polygon Official WebSocket', url: 'wss://polygon-bor.publicnode.com', type: 'ws' },
      { name: 'Alchemy HTTP', url: 'https://polygon-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'http' },
      { name: 'Alchemy WebSocket', url: 'wss://polygon-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/polygon', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/polygon/ws', type: 'ws' },
      { name: 'Public WebSocket', url: 'wss://polygon.publicnode.com', type: 'ws' }
    ],
    explorer: 'https://polygonscan.com'
  },
  arbitrum: {
    id: 42161,
    name: 'Arbitrum One',
    symbol: 'ETH',
    blockTime: 250, // 0.25 秒
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: true
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      mevBlocker: 'https://rpc.mevblocker.io/arbitrum'
    },
    rpcs: [
      { name: 'Arbitrum Official HTTP', url: 'https://arb1.arbitrum.io/rpc', type: 'http' },
      { name: 'Arbitrum Official WebSocket', url: 'wss://arb1.arbitrum.io/ws', type: 'ws' },
      { name: 'Alchemy HTTP', url: 'https://arb-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'http' },
      { name: 'Alchemy WebSocket', url: 'wss://arb-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/arbitrum', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/arbitrum/ws', type: 'ws' },
      { name: 'Public HTTP', url: 'https://arbitrum.publicnode.com', type: 'http' }
    ],
    explorer: 'https://arbiscan.io'
  },
  optimism: {
    id: 10,
    name: 'Optimism',
    symbol: 'ETH',
    blockTime: 2000, // 2 秒
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: true
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      mevBlocker: 'https://rpc.mevblocker.io/optimism'
    },
    rpcs: [
      { name: 'Optimism Official HTTP', url: 'https://mainnet.optimism.io', type: 'http' },
      { name: 'Optimism Official WebSocket', url: 'wss://ws-mainnet.optimism.io', type: 'ws' },
      { name: 'Alchemy HTTP', url: 'https://opt-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'http' },
      { name: 'Alchemy WebSocket', url: 'wss://opt-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/optimism', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/optimism/ws', type: 'ws' },
      { name: 'Public HTTP', url: 'https://optimism.publicnode.com', type: 'http' }
    ],
    explorer: 'https://optimistic.etherscan.io'
  },
  avalanche: {
    id: 43114,
    name: 'Avalanche C-Chain',
    symbol: 'AVAX',
    blockTime: 1500, // dynamic C-Chain fallback; observed public RPC is ~1-2s
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: false
    },
    rpcs: [
      { name: 'Avalanche Official HTTP', url: 'https://api.avax.network/ext/bc/C/rpc', type: 'http' },
      { name: 'Avalanche Official WebSocket', url: 'wss://api.avax.network/ext/bc/C/ws', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/avalanche', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/avalanche/ws', type: 'ws' },
      { name: 'Public HTTP', url: 'https://avalanche.publicnode.com', type: 'http' }
    ],
    explorer: 'https://snowtrace.io'
  },
  xlayer: {
    id: 196,
    name: 'X Layer',
    symbol: 'OKB',
    blockTime: 1000, // 1s X Layer L2 blocks
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: false
    },
    rpcs: [
      { name: 'X Layer Official HTTP', url: 'https://rpc.xlayer.tech', type: 'http' },
      { name: 'X Layer Official WebSocket', url: 'wss://ws.xlayer.tech', type: 'ws' },
      { name: 'OKX RPC HTTP', url: 'https://xlayerrpc.okx.com', type: 'http' },
      { name: 'Public HTTP 1', url: 'https://rpc.ankr.com/xlayer', type: 'http' },
      { name: 'Public HTTP 2', url: 'https://xlayer.publicnode.com', type: 'http' }
    ],
    explorer: 'https://www.okx.com/explorer/xlayer'
  },
  base: {
    id: 8453,
    name: 'Base',
    symbol: 'ETH',
    blockTime: 2000, // 2 秒
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: true,
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
      mevBlocker: 'https://rpc.mevblocker.io/base'
    },
    rpcs: [
      { name: 'Public HTTP', url: 'https://base.publicnode.com', type: 'http' },
      { name: 'Base Official HTTP', url: 'https://mainnet.base.org', type: 'http' },
      { name: 'Base Official WebSocket', url: 'wss://mainnet.base.org', type: 'ws' },
      { name: 'Alchemy HTTP', url: 'https://base-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'http' },
      { name: 'Alchemy WebSocket', url: 'wss://base-mainnet.g.alchemy.com/v2/YOUR_API_KEY', type: 'ws' },
      { name: 'Infura HTTP', url: 'https://base-mainnet.infura.io/v3/YOUR_API_KEY', type: 'http' },
      { name: 'Infura WebSocket', url: 'wss://base-mainnet.infura.io/ws/v3/YOUR_API_KEY', type: 'ws' },
      { name: 'Ankr HTTP', url: 'https://rpc.ankr.com/base', type: 'http' },
      { name: 'Ankr WebSocket', url: 'wss://rpc.ankr.com/base/ws', type: 'ws' },
      { name: 'Public WebSocket', url: 'wss://base.publicnode.com', type: 'ws' },
      { name: '1RPC HTTP', url: 'https://1rpc.io/base', type: 'http' },
      { name: 'BlockPI HTTP', url: 'https://base.blockpi.network/v1/rpc/public', type: 'http' }
    ],
    explorer: 'https://basescan.org'
  },
  robinhood: {
    id: 4663,
    name: 'Robinhood Chain',
    symbol: 'ETH',
    blockTime: 1000, // 1s fallback; official public RPC is verified live before use
    // Transaction type support
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV protection support
    mevProtection: {
      flashbots: false,
      mevBlocker: false,
    },
    // MEV protection RPC endpoints
    mevRpcs: {
    },
    rpcs: [
      { name: 'Robinhood Official HTTP', url: 'https://rpc.mainnet.chain.robinhood.com', type: 'http' }
    ],
    explorer: 'https://robinhoodchain.blockscout.com'
  },
  abstract: {
    id: 2741,
    name: 'Abstract',
    symbol: 'ETH',
    blockTime: 500, // observed public RPC/explorer is ~0.4-0.5s; calibrated on connect
    // 交易類型支援
    supportsEIP1559: true,
    supportsLegacy: true,
    // MEV 保護支援
    mevProtection: {
      flashbots: false,
      mevBlocker: false,
    },
    // MEV 保護 RPC 端點
    mevRpcs: {
    },
    rpcs: [
      { name: 'Abstract Mainnet API', url: 'https://api.mainnet.abs.xyz', type: 'http' },
      { name: 'Public HTTP', url: 'https://abstract.publicnode.com', type: 'http' },
      { name: 'OnFinality HTTP', url: 'https://abstract.api.onfinality.io/public', type: 'http' },
      { name: 'DRPC WebSocket', url: 'wss://abstract.drpc.org', type: 'ws' },
      { name: 'DRPC HTTP', url: 'https://abstract.drpc.org', type: 'http' },
      { name: 'Abstract Official HTTP', url: 'https://api.abstract.xyz', type: 'http' },
      { name: 'Abstract Official WebSocket', url: 'wss://api.abstract.xyz/ws', type: 'ws' },
      { name: 'Abstract RPC 1', url: 'https://rpc.abstract.xyz', type: 'http' },
      { name: 'Abstract RPC 2', url: 'https://rpc-2741.abstract.xyz', type: 'http' }
    ],
    explorer: 'https://explorer.abstract.xyz'
  }
};

// 各鏈的原生代幣包裝合約地址
export const WRAPPED_NATIVE_TOKEN = {
  1: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH
  56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', // WBNB
  137: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', // WPOL
  42161: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', // WETH
  10: '0x4200000000000000000000000000000000000006', // WETH
  43114: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', // WAVAX
  196: '0xe538905cf8410324e03A5A23C1c177a474D59b2b', // WOKB
  8453: '0x4200000000000000000000000000000000000006', // WETH (Base)
  4663: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73', // WETH (Robinhood Chain)
  2741: '0x3439153EB7AF838Ad19d56E1571FBD09333C2809' // WETH9
};

// Wrapped Native Token 符號映射
export const WRAPPED_NATIVE_TOKEN_SYMBOL = {
  1: 'WETH',
  56: 'WBNB',
  137: 'WPOL',
  42161: 'WETH',
  10: 'WETH',
  43114: 'WAVAX',
  196: 'WOKB',
  8453: 'WETH', // Base
  4663: 'WETH',
  2741: 'WETH'
};

// 常用穩定幣地址
export const STABLECOINS = {
  ethereum: {
    USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F'
  },
  bsc: {
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    BUSD: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
  },
  polygon: {
    USDT: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    USDC: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    DAI: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063'
  },
  arbitrum: {
    USDC: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
    USDC_E: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
    USDT: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
    DAI: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1'
  },
  optimism: {
    USDC: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
    USDC_E: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
    USDT: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
    DAI: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1'
  },
  avalanche: {
    USDC: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
    USDT: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
    DAI_E: '0xd586e7f844cea2f87f50152665bcbc2c279d8d70'
  },
  xlayer: {
    USDT: '0x1E4a5963aBFD975d8c9021ce480b42188849D41d',
    USDC: '0x74b7F16337b8972027F6196A17a631aC6dE26d22'
  },
  base: {
    USDC: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    USDT: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
    DAI: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb'
  },
  robinhood: {
    USDG: '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168'
  },
  abstract: {
    USDT: '0x0709F39376dEEe2A2dfC94A58EdEb2Eb9DF012bD',
    USDC: '0x84A71ccD554Cc1b02749b35d22F684CC8ec987e1'
  }
};

// Gas 限制常數
export const GAS_LIMITS = {
  APPROVE: 50000,
  TRANSFER: 65000,
  SWAP_V2: 200000,
  SWAP_V3: 250000,
  ADD_LIQUIDITY: 300000,
  REMOVE_LIQUIDITY: 250000
};

// 獲取 MEV 保護 RPC URL
export const getMevRpcUrl = (chainKey, mevProtection) => {
  const chainConfig = SUPPORTED_CHAINS[chainKey];
  
  // 如果不使用 MEV 保護，返回 null
  if (!mevProtection || mevProtection === 'none') {
    return null;
  }
  
  // 檢查該鏈是否支援選擇的 MEV 保護
  if (!chainConfig?.mevProtection?.[mevProtection]) {
    console.warn(`${chainConfig?.name} 不支援 ${mevProtection}`);
    return null;
  }
  
  // 返回對應的 MEV RPC URL
  return chainConfig?.mevRpcs?.[mevProtection] || null;
};

// 獲取區塊鏈瀏覽器的交易 URL
export const getExplorerTxUrl = (chainKey, txHash) => {
  const chainConfig = SUPPORTED_CHAINS[chainKey];
  
  if (!chainConfig?.explorer) {
    console.warn(`${chainKey} 沒有配置區塊鏈瀏覽器`);
    return null;
  }
  
  return `${chainConfig.explorer}/tx/${txHash}`;
};

// 獲取區塊鏈瀏覽器的地址 URL
export const getExplorerAddressUrl = (chainKey, address) => {
  const chainConfig = SUPPORTED_CHAINS[chainKey];
  
  if (!chainConfig?.explorer) {
    console.warn(`${chainKey} 沒有配置區塊鏈瀏覽器`);
    return null;
  }
  
  return `${chainConfig.explorer}/address/${address}`;
};
